module.exports = __webpack_public_path__ + "static/media/manage.c8b1280a.svg";